export const insightsDetailsGet = (data) => {
    return data.data;
}

export const messagingInsightsDetailsGet = (data) => {
    return data.data;
}

export const messageTemplateInsightsDetailsGet = (data) => {
    return data.data;
}

export const messageTemplateInsightsDetailsRankWiseGet = (data) => {
    return data.data;
}

export const notificationsInsightsDetailsGet = (data) => {
    return data.data;
}

export const contactsInsightsDetailsGet = (data) => {
    return data.data;
}

export const contactsPositiveLeadsGet = (data) => {
    return data.data;
}

export const messagingPricingInsightsDetailsGet = (data) => {
    return data.data;
}

export const loadCampaignChartGet = (data) => {
    return data.data;
}

export const taskDetailsGet = (data) => {
    return data.data;
}

export const saveActivityPost = (data) => {
    return data.data;
}

export const updateTaskPatch = (data) => {
    return data.data;
}

export const addNoteListingPost = (data) => {
    return data.data;
}

export const editActivityPut = (data) => {
    return data.data;
}
